import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/[lang]/feedback/page.tsx");
